export const ASSETS_REQUESTS = 'assetsRequests';
export const CHECK_ASSETS = 'checkAssets';
export const EMPLOYMENT_STATUS_REQUEST = 'employmentStatusRequest';
export const POST_TAXPAYER_EMPLOYMENT_STATUS = 'postTaxpayerEmploymentStatus';
export const POST_SPOUSE_EMPLOYMENT_STATUS = 'postSpouseEmploymentStatus';
export const EMPLOYMENT_STATUS_SUCCESS = 'employmentStatusSuccess';
export const POST_TAXPAYER_EMPLOYMENT_STATUS_SUCCESS = 'postTaxpayerEmploymentStatusSuccess';
export const POST_SPOUSE_EMPLOYMENT_STATUS_SUCCESS = 'postSpouseEmploymentStatusSuccess';
export const TAXPAYER_JOBS_REQUEST = 'taxpayerJobsRequest';
export const MARITAL_STATUS_REQUEST_SUCCESS = 'maritalStatusRequestSuccess';
export const SPOUSE_JOBS_REQUEST = 'spouseJobsRequest';
export const EMPLOYMENT_LOADING = 'employmentLoading';
export const TAXPAYER_EMPLOYMENT_SUCCESS = 'taxpayerEmploymentSuccess';
export const SPOUSE_EMPLOYMENT_SUCCESS = 'spouseEmploymentSuccess';
export const EMPLOYMENT_ERROR = 'employmentError';
export const POST_NEW_TAXPAYER_JOB = 'postNewTaxpayerJob';
export const NEW_TAXPAYER_JOB_SUCCESS = 'newTaxpayerJobSuccess';
export const DELETE_TAXPAYER_JOB = 'deleteTaxpayerJob';
export const DELETE_TAXPAYER_JOB_SUCCESS = 'deleteTaxpayerJobSuccess';
export const EDIT_TAXPAYER_JOB = 'editTaxpayerJob';
export const EDIT_TAXPAYER_JOB_SUCCESS = 'editTaxpayerJobSuccess';
export const TAXPAYER_JOB_ITEM_REQUEST = 'taxpayerJobItemRequest';
export const TAXPAYER_JOB_ITEM_SUCCESS = 'taxpayerJobItemSuccess';
export const POST_NEW_SPOUSE_JOB = 'postNewSpouseJob';
export const NEW_SPOUSE_JOB_SUCCESS = 'newSpouseJobSuccess';
export const DELETE_SPOUSE_JOB = 'deleteSpouseJob';
export const DELETE_SPOUSE_JOB_SUCCESS = 'deleteSpouseJobSuccess';
export const EDIT_SPOUSE_JOB = 'editSpouseJob';
export const EDIT_SPOUSE_JOB_SUCCESS = 'editSpouseJobSuccess';
export const SPOUSE_JOB_ITEM_REQUEST = 'spouseJobItemRequest';
export const SPOUSE_JOB_ITEM_SUCCESS = 'spouseJobItemSuccess';
export const REAL_ESTATE_REQUEST = 'realEstateRequest';
export const REAL_ESTATE_LOADING = 'realEstateLoading';
export const REAL_ESTATE_SUCCESS = 'realEstateSuccess';
export const REAL_ESTATE_ERROR = 'realEstateError';
export const POST_NEW_REAL_ESTATE = 'postNewRealEstate';
export const NEW_REAL_ESTATE_SUCCESS = 'newRealEstateSuccess';
export const DELETE_REAL_ESTATE = 'deleteRealEstate';
export const DELETE_REAL_ESTATE_SUCCESS = 'deleteRealEstateSuccess';
export const EDIT_REAL_ESTATE = 'editRealEstate';
export const EDIT_REAL_ESTATE_SUCCESS = 'editRealEstateSuccess';
export const REAL_ESTATE_ITEM_REQUEST = 'realEstateItemRequest';
export const REAL_ESTATE_ITEM_SUCCESS = 'realEstateItemSuccess';
export const VEHICLES_REQUEST = 'vehiclesRequest';
export const VEHICLES_LOADING = 'vehiclesLoading';
export const VEHICLES_SUCCESS = 'vehiclesSuccess';
export const VEHICLES_ERROR = 'vehiclesError';
export const POST_NEW_VEHICLE = 'postNewVehicle';
export const NEW_VEHICLE_SUCCESS = 'newVehicleSuccess';
export const DELETE_VEHICLE = 'deleteVehicle';
export const DELETE_VEHICLE_SUCCESS = 'deleteVehicleSuccess';
export const EDIT_VEHICLE = 'editVehicle';
export const EDIT_VEHICLE_SUCCESS = 'editVehicleSuccess';
export const VEHICLE_ITEM_REQUEST = 'vehicleItemRequest';
export const VEHICLE_ITEM_SUCCESS = 'vehicleItemSuccess';
export const OTHER_ASSETS_REQUEST = 'otherAssetsRequests';
export const OTHER_ASSETS_LOADING = 'otherAssetsLoading';
export const OTHER_ASSETS_SUCCESS = 'otherAssetsSuccess';
export const OTHER_ASSETS_ERROR = 'otherAssetsError';
export const POST_NEW_ASSET = 'postNewAsset';
export const NEW_ASSET_SUCCESS = 'newAssetSuccess';
export const DELETE_ASSET = 'deleteAsset';
export const DELETE_ASSET_SUCCESS = 'deleteAssetSuccess';
export const EDIT_ASSET = 'editAsset';
export const EDIT_ASSET_SUCCESS = 'editAssetSuccess';
export const ASSET_ITEM_REQUEST = 'assetItemRequest';
export const ASSET_ITEM_SUCCESS = 'assetItemSuccess';
export const HOUSEHOLD_REQUEST = 'householdRequest';
export const HOUSEHOLD_LOADING = 'householdLoading';
export const HOUSEHOLD_SUCCESS = 'householdSuccess';
export const HOUSEHOLD_ERROR = 'householdError';
export const POST_HOUSEHOLD = 'postHousehold';
